document.addEventListener('DOMContentLoaded', function () {
  function initSwiperWhenReady() {
    if (typeof Swiper !== 'undefined') {
      const swiperEl = document.querySelector('.mySwiper');
      if (!swiperEl) return;

      const autoplayEnabled = swiperEl.dataset.autoplay === 'true';
      const autoplayDelay = parseInt(swiperEl.dataset.delay) || 5000;

      new Swiper('.mySwiper', {
        spaceBetween: 30,
        centeredSlides: true,
        ...(autoplayEnabled && {
          autoplay: {
            delay: autoplayDelay,
            disableOnInteraction: false
          }
        }),
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          renderBullet: function (index, className) {
            return `<span class="${className}"><span class="progress-bar"></span></span>`;
          }
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        on: {
          slideChangeTransitionStart: function () {
            const bullets = document.querySelectorAll('.swiper-pagination-bullet');
            bullets.forEach((bullet, index) => {
              const bar = bullet.querySelector('.progress-bar');
              bar.style.transition = 'none';
              bar.style.width = '0%';
              bar.classList.remove('progress-animate');

              if (index === this.realIndex) {
                setTimeout(() => {
                  bar.style.transition = `width ${autoplayDelay}ms linear`;
                  bar.classList.add('progress-animate');
                  bar.style.width = '100%';
                }, 50);
              }
            });
          },
          init: function () {
            setTimeout(() => {
              const activeBar = document.querySelector('.swiper-pagination-bullet-active .progress-bar');
              if (activeBar) {
                activeBar.style.transition = `width ${autoplayDelay}ms linear`;
                activeBar.classList.add('progress-animate');
                activeBar.style.width = '100%';
              }
            }, 50);
          }
        }
      });
    } else {
      setTimeout(initSwiperWhenReady, 50);
    }
  }

  initSwiperWhenReady();
});
